import {
  BrowserCacheLocation,
  type Configuration,
  type RedirectRequest,
  type SilentRequest
} from '@azure/msal-browser';
import { environment } from '../../environments/environment';

export const entraAuthConfig = {
  ...environment.entra
};

export const msalBrowserConfig: Configuration = {
  auth: {
    clientId: entraAuthConfig.clientId,
    authority: `https://login.microsoftonline.com/${entraAuthConfig.tenantId}`,
    redirectUri: entraAuthConfig.redirectUri,
    postLogoutRedirectUri: entraAuthConfig.postLogoutRedirectUri
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage
  }
};

export const loginRequest: RedirectRequest = {
  scopes: [...entraAuthConfig.scopes, ...entraAuthConfig.apiScopes]
};

export const apiTokenRequest = {
  scopes: entraAuthConfig.apiScopes
} satisfies Pick<SilentRequest, 'scopes'>;
